import "../css/toggle.css";
import "../css/imageSlider.css";
import { useState } from "react";
import { ESPANOL, ENGLISH } from "../consts.js";

function ImageSlider() {
  const images = [
    "https://scontent-atl3-2.xx.fbcdn.net/v/t51.82787-15/581227545_17948612049066377_431628346272055097_n.jpg?_nc_cat=102&ccb=1-7&_nc_sid=127cfc&_nc_ohc=XI-MV_-IC7kQ7kNvwGjvwWX&_nc_oc=AdlGJpHKqTU1ZKsxhd4Sa3QOPfK6eC-gHAzzl8qalPlZbfwir-JuCwv0BSSFAsLyKUGUIP0itNe5YbwnqmAhkVRI&_nc_zt=23&_nc_ht=scontent-atl3-2.xx&_nc_gid=1eex0yLJ8nS9QSyaED_dCQ&oh=00_AfgBAI-VnU3DNfZwg1uAw40E7cS6YmWPKm1XSLSIz0hrRg&oe=691E7F8A",
    "https://scontent-atl3-1.xx.fbcdn.net/v/t51.82787-15/582205752_17948612058066377_7676489216781016808_n.jpg?stp=dst-jpegr_tt6&_nc_cat=100&ccb=1-7&_nc_sid=127cfc&_nc_ohc=hMoL6fayIekQ7kNvwHQjpxm&_nc_oc=AdnoTNoL3Dd4_bOHSAHGupvzOetEAUiV2noIIrlJQVpfPfrd96u8ZVSrSeuyr2_NTCbNJktLx1Ev709CpF0UqMiY&_nc_zt=23&se=-1&_nc_ht=scontent-atl3-1.xx&_nc_gid=wzgGwBLXNwHz2ZeQCwECnw&oh=00_AfhDJthB6WzBYDvgdaL88EP4ZN7l2kHjCnJgCKsSWLnl9Q&oe=691E7068",
    "https://scontent-atl3-1.xx.fbcdn.net/v/t51.82787-15/581063736_17948612037066377_8780647164264011881_n.jpg?stp=dst-jpegr_tt6&_nc_cat=100&ccb=1-7&_nc_sid=127cfc&_nc_ohc=arn5cCsVSEsQ7kNvwHliFoz&_nc_oc=AdlJdWoW3PGu1rvXTO8aWRM1VVnxBzW51kP-8TYUlWWGv6JcVxnm-EtfzEFkv82R29JuEv654Hp_5JK9rSOTFIbu&_nc_zt=23&se=-1&_nc_ht=scontent-atl3-1.xx&_nc_gid=b0WipTJ9PRMiYS6nhR4MmQ&oh=00_Afh50dQZUv8XLH-9a0cVuNSg2JNHmKDLq7lIOUl8Ae3OUQ&oe=691E9842",
  ];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [image, setImage] = useState(images[0]);
  function handleImageChange(direction) {
    if (direction === "left") {
      setCurrentIndex(
        currentIndex === 0 ? images.length - 1 : currentIndex - 1
      );
    } else {
      setCurrentIndex(
        currentIndex === images.length - 1 ? 0 : currentIndex + 1
      );
    }
    setImage(images[currentIndex]);
  }

  return (
    <div className="ImageSlider">
      <div
        className="arrow left"
        onClick={() => {
          handleImageChange("left");
        }}
      >
        <img src="/left.svg" alt="Left arrow" />
      </div>
      <img src={image} alt="Location Image" />
      <div
        className="arrow right"
        onClick={() => {
          handleImageChange("right");
        }}
      >
        <img src="/right.svg" alt="Right arrow" />
      </div>
    </div>
  );
}

export default ImageSlider;
